import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, List, ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { NombrePilaVariacion } from './NombrePilaVariacion';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { NombrePila } from '../NombresPila/NombrePila';
import ErrorDialog from '../utilities/ErrorDialog';

export interface INombrePilaVariacionNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface INombrePilaVariacionNewState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    errors: any[];
    nombresPila: NombrePila[];
    openErroDialog: boolean;
}

export default class NombrePilaVariacionNew extends React.Component<INombrePilaVariacionNewProps, INombrePilaVariacionNewState> {
    _nombrePilaVariacion: NombrePilaVariacion = new NombrePilaVariacion();
    
    public constructor(props: INombrePilaVariacionNewProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            errors: [],
            nombresPila: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetNombresPila();
    }

    componentWillReceiveProps(nextProps: Readonly<INombrePilaVariacionNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open && this.state.errors.length == 0} fullWidth>
                    <DialogTitle>
                        Nueva variante de nombre de pila
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl required fullWidth variant="standard">
                                <Autocomplete
                                    defaultValue={this._nombrePilaVariacion.nombrePila}
                                    options={this.GetAutocompleteOptions()}
                                    getOptionLabel={(option: any) => option.nombre!}
                                    onChange={(event: any, newValue: any) => {
                                        this._nombrePilaVariacion.nombrePila = newValue.nombre;
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Nombre" variant="standard"/>
                                    )}
                                    renderOption={(props, item) => (
                                        <li {...props} key={item.id}>
                                          <ListItemText>{item.nombre}</ListItemText>
                                        </li>
                                    )}
                                />
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Variación' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._nombrePilaVariacion.variacion = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Save.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.errors.length > 0} fullWidth>
                    <DialogTitle>
                        Error
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant='body2'>
                            Se ha producido el siguiente error al guardar los datos:
                        </Typography>
                        <div className='errors'>
                            <List>
                                {
                                    this.state.errors.map((value: string, index: number) => {
                                        return (
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CancelOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={value} />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })
                                }
                            </List>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            this.setState(
                                {
                                    errors: []
                                }
                            );
                        }}>Ok</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Save() {
        if(this._nombrePilaVariacion.variacion == '' || this._nombrePilaVariacion.nombrePila == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/nombrespilavariacion`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._nombrePilaVariacion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._nombrePilaVariacion = new NombrePilaVariacion();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._nombrePilaVariacion = new NombrePilaVariacion();
        });
    }

    private GetNombresPila(): void {
        let url = `${Common.END_POINT}/masters/nombrespila`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    nombresPila: response
                }
            );
        })
    }

    private GetAutocompleteOptions() {
        const options: any[] = [];

        for(let i = 0; i < this.state.nombresPila.length; i++) {
            const nombre = this.state.nombresPila[i];
            options.push(
                {
                    id: nombre.id,
                    nombre: nombre.nombre
                }
            )
        }

        return options;
    }
}